// API Endpoints
export const APP_ROUTES = {
  LOGIN: '/login',
  HOME: '/dashboard',
  CONTACT_VERIFICATION: '/contact-verification',
  KYC_VERIFICATION: '/kyc-verification'
};

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh-token',
    KYC: '/employers/kyc/documents'
  },
  JOBS: {
    BASE: '/jobs',
    MATCHES: '/jobs/:id/matches',
    PUBLISH: '/jobs/:id/publish'
  },
  CANDIDATES: {
    BASE: '/candidates',
    MATCHES: '/candidates/matches'
  }
};

// KYC Documents by Region
export const KYC_DOCUMENTS = {
  Africa: 'Certificate of Incorporation',
  USA: 'Unique Entity Identifier (UEI)',
  UK: 'DUNS Number',
  EU: 'VAT ID or EORI Number',
  Australia: 'ABN',
  Asia: 'Incorporation Certificate',
  'South America': 'CNPJ or national registration ID',
  'Gulf Region': 'Commercial Registration + Chamber Certificate'
};

// Matching Bands
export const MATCHING_BANDS = {
  BAND_A: { min: 70, max: 100, label: 'Band A (70-100%)' },
  BAND_B: { min: 50, max: 70, label: 'Band B (50-70%)' },
  BAND_C: { min: 30, max: 50, label: 'Band C (30-50%)' },
  BAND_D: { min: 0, max: 30, label: 'Band D (0-30%)' }
};

// Job Types
export const JOB_TYPES = [
  'Full-time',
  'Part-time',
  'Contract',
  'Freelance',
  'Internship',
  'Temporary'
];

// Industries
export const INDUSTRIES = [
  'Technology',
  'Healthcare',
  'Finance',
  'Education',
  'Manufacturing',
  'Retail',
  'Consulting',
  'Media',
  'Real Estate',
  'Other'
];

// Countries/Regions
export const REGIONS = [
  'Africa',
  'USA',
  'UK',
  'EU',
  'Australia',
  'Asia',
  'South America',
  'Gulf Region'
];
